import React from 'react'

export const ErrorSection = ({href}) => {

  return (
    <div className='flex flex-column gap-32 ai-center'>
        <div className='flex jc-center ai-center'>
            <img
                src="https://especialess3.lanacion.com.ar/LN/newsletter/_common/images/newsletters-img--error-section.png"
                alt="Dibujo de caja vacía, sin newsletters "
                width="127"
                height="151"
            />
        </div>
        <h1 className='--prumo text-24 --font-bold text-center'>No hay newsletters para administrar</h1>
        <p className='text-center'>Te vamos a avisar cuando tengas nuevos newsletters para administrar.</p>
        <a title="Ir a newsletters" href={href} className='uppercase text-12 font-bold --arial bg-blue-500 text-neutral-light-1 px-16 py-12 rounded-4'>Ir a newsletters</a>
    </div>
  )
}

export default ErrorSection;